// extracted by mini-css-extract-plugin
export default {"header":"Header_header__G4l+R","headerContent":"Header_headerContent__C5G9V"};